import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { BOOKING_URL, BOOKING_EVENT } from "../utils/booking";
import { useLanguage } from "../context/LanguageContext";

const BookingModal = () => {
  const { lang } = useLanguage();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener(BOOKING_EVENT, onOpen);
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener(BOOKING_EVENT, onOpen); window.removeEventListener("keydown", onKey); };
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      onClick={() => setOpen(false)}
      data-testid="booking-modal"
    >
      <div
        className="relative w-full max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-narwhal-dark shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
          <h2 className="text-sm font-semibold text-white">
            {lang === "en" ? "Book a demo call" : "Agendá una llamada de demo"}
          </h2>
          <button
            onClick={() => setOpen(false)}
            data-testid="booking-modal-close"
            aria-label="Close"
            className="rounded-full p-1.5 text-narwhal-muted transition-colors hover:bg-white/10 hover:text-white"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <iframe
          title="Narwhal booking"
          src={BOOKING_URL}
          className="h-[70vh] w-full border-0 bg-white"
          loading="lazy"
          allow="payment"
          data-testid="booking-iframe"
        />
      </div>
    </div>
  );
};

export default BookingModal;
